export const DISCLAIMER_MODAL_ID = 'disclaimer-modal';
/** Fired on window when the sign-in disclaimer is accepted. */
export const DISCLAIMER_ACCEPTED_EVENT = 'vh3:disclaimer-accepted';
export const PASSKEY_ENROL_MODAL_ID = 'passkey-enrol-modal';
export const EXTERNAL_LINK_DISCLAIMER_MODAL_ID =
  'external-link-disclaimer-modal';
export const MESSAGE_FEEDBACK_MODAL_ID = 'message-feedback-modal';
export const JOBS_FILTERS_MOBILE_MODAL_ID = 'jobs-filters-mobile-modal';
export const CASES_FILTERS_MOBILE_MODAL_ID = 'cases-filters-mobile-modal';
export const PORTAL_JOBS_FILTERS_MOBILE_MODAL_ID =
  'portal-jobs-filters-mobile-modal';
export const TEAMS_FILTERS_MOBILE_MODAL_ID = 'teams-filters-mobile-modal';
export const LINKED_ITEMS_FILTERS_MOBILE_MODAL_ID =
  'linked-items-filters-mobile-modal';
